import React from 'react';
import { useParams } from 'react-router-dom';
import EditableBranchTemplate from '../components/EditableBranchTemplate';
import { getTopicBySlug, saveTopic } from '../services/topicRegistry';

const TopicPage = () => {
  const { slug } = useParams();
  const topic = getTopicBySlug(slug);

  if (!topic) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Topic not found.
      </div>
    );
  }

  return (
    <EditableBranchTemplate
      title={topic.title}
      sections={topic.sections}
      onSave={(sections) => saveTopic({ ...topic, sections })}
      startEditing={false}
    />
  );
};

export default TopicPage;


